import React from 'react';
import { motion } from 'framer-motion';
import './TrustBadges.css';

const TrustBadges = () => {
  const badges = [
    { icon: '✓', text: 'Secure Payment via CCAvenue' },
    { icon: '✓', text: 'NSE Registered Member' },
    { icon: '✓', text: 'Your Data Protected' }
  ];

  return (
    <section className="trust-section">
      <div className="container">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Secure & Trusted
        </motion.h3>
        
        <motion.div
          className="trust-badges"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {badges.map((badge, index) => (
            <motion.div
              key={index}
              className="trust-badge"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <span className="badge-icon">{badge.icon}</span>
              <span>{badge.text}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBadges;

